/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useEffect, useState } from "react";

import { cssFns } from "@superweb/css";
import { LinkButton, useTypo, useUiColors } from "@superweb/ui";
import { useFormat } from "@superweb/intl";

import { Message, useMessage } from "#internal/intl";
import { useLogAction } from "#internal/analytics/logActions";
import taxSystemOsnoBannerIcon from "#internal/images/tax-system-osno-banner-icon.svg";

export const TaxSystemOsnoBanner = () => {
  const typo = useTypo();
  const uiColors = useUiColors();
  const message = useMessage();
  const logAction = useLogAction("tax_system");
  const { formatPercent } = useFormat();
  const [hasLoggedShown, setHasLoggedShown] = useState(false);

  useEffect(() => {
    if (!hasLoggedShown) {
      logAction("tax_system_osno_banner_shown");
      setHasLoggedShown(true);
    }
  }, [hasLoggedShown, logAction]);

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginBlockEnd: "16px",
        ...cssFns.padding("8px", "16px"),
        paddingBlockStart: "12px",
        ...cssFns.border({
          radius: "16px",
        }),
        backgroundColor: uiColors.controlMinor,
      }}
    >
      <img
        css={{
          width: "auto",
          maxWidth: "100%",
          maxHeight: "50px",
          objectFit: "contain",
        }}
        src={taxSystemOsnoBannerIcon}
        alt={message({
          id: "f153585e-eb8b-4820-b848-b39aa1135494",
          context: "Driver form. Tax system OSNO banner. Banner icon alt text.",
          default: "Banner icon",
        })}
      />
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          rowGap: "8px",
          ...cssFns.padding("8px", "0"),
        }}
      >
        <div>
          <div
            css={typo({
              level: "body2",
              density: "tight",
              weight: "medium",
            })}
          >
            <Message
              id="954d2373-2da1-4cbf-b57d-dec7f32f8e3a"
              context="Driver form. Tax system OSNO banner. Banner title."
              default="General taxation and patent with the general taxation aren't optimal"
            />
          </div>
          <div
            css={typo({
              level: "body2",
              density: "tight",
              weight: "regular",
            })}
          >
            <Message
              id="bcd0f15d-521c-445e-bf58-fa07553d1a8c"
              context="Driver form. Tax system OSNO banner. Banner text."
              default="High tax — {totalPercent} ({personalTaxPercent} personal income tax + {vatPercent} VAT), complex reporting. Contractors more often choose the simplified taxation, which they can switch to within a month after registering as an Individual Entrepreneur or at the beginning of the year"
              values={{
                totalPercent: formatPercent(0.35),
                personalTaxPercent: formatPercent(0.13),
                vatPercent: formatPercent(0.22),
              }}
            />
          </div>
        </div>
        <LinkButton
          size="xs"
          link={{
            href: "https://parks.yandex/ru-ru/moskva/knowledge-base/legalization/legal-driver/check-ip-driver-tax-system?section=если-водитель-выбрал-осно",
            external: true,
          }}
          text={message({
            id: "661fff03-cc07-435d-b884-32f9689f929a",
            context: "Driver form. Tax system OSNO banner. Banner button text",
            default: "How to switch to simplified taxation",
          })}
          onPress={() => logAction("tax_system_osno_banner_clicked")}
        />
      </div>
    </div>
  );
};
